export function delay(milliseconds: number): Promise<void> {
  return new Promise<void>((resolve, _reject) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}
